import { DataService } from './../../../../services/data.service';
import { User } from './../../../../interfaces/user';
import { FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Transaction } from 'src/app/interfaces/transactions';
import * as _ from 'lodash';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent implements OnInit {

  transactions: Transaction[];
  showData: any[];

  currentPage = 1;
  totalItemsPerPage = 20;

  showSettings = false;

  searchForm = new FormControl('');
  transactionFilter = 0;

  constructor(
    private data: DataService
  ) { }

  ngOnInit() {
    this.searchForm.valueChanges.subscribe(async (v) => {
      if(!v){
        this.showData = this.transactions;
        return;
      }

      let data = _.filter(this.transactions, (i) => !(this.transactionFilter !== 0 && i.type !== this.transactionFilter));

      if(!Number.isNaN(+v)){
        this.showData = _.filter(data, (i) => String.prototype.search.call(i.auto_id, new RegExp(v, 'gi')) !== -1);
        return;
      }

      this.showData = _.filter(data, (i) => (i.debit_user && String.prototype.search.call((<User>i.debit_user).name, new RegExp(v, 'gi')) !== -1) || (i.credit_user && String.prototype.search.call((<User>i.credit_user).name, new RegExp(v, 'gi')) !== -1));
    })

    this.getData();
  }

  getData(){
    this.data.getAllTransactions().subscribe((res) => {
      if(res && res.data){
        this.transactions = res.data;
        this.showData = res.data;

        console.log(res.data);
      }
    })
  }

  filterTransactions({value}){
    let data = this.transactions;

    this.transactionFilter = value;

    if(this.searchForm.value){
      data = _.filter(data, (i) => {
        const regex = new RegExp(this.searchForm.value, 'gi');

        return String.prototype.search.call(i.auto_id, regex) !== -1 || (i.debit_user && String.prototype.search.call((<User>i.debit_user).name, regex) !== -1) || (i.credit_user && String.prototype.search.call((<User>i.credit_user).name, regex) !== -1);
      });
    }

    this.showData = value === 0 ? data : _.filter(data, {type: value});
  }
}
